let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7QZ5r")).then(() => parcelRequire('jhz3p'));